import vendor from './vendor';
import invoice from './invoice'
import requisition from './requisition';
import purchaseOrder from './purchaseOrder';
import supplier from './supplier';
import order from './order';
import item from './item';
import currency from './currency';
import warehouse from './warehouse';
import tax from './tax';
import payment from './payment';
import paymentMode from './paymentMode';
import goodReceipt from './goodReceipt';
import creditNote from './creditNote';
import ledgerAccount from './ledgerAccount';
import supplierGroup from './supplierGroup';
import supplierGroupList from './supplierGroupList';
import supplierAccount from './supplierAccount';
import supplierContact from './supplierContact';
import priority from './priority';
import debitNote from './debitNote';
import supplierAccountStatement from './supplierAccountStatement'
import paymentAccount from './paymentAccount';
import account from './account';
import generalReceipt from './generalReceipt';
import priceChecker from './priceChecker';

export default {
    namespaced: true,
    state: {
        routePrefix: '/purchase',
        priority: [
            {id: 1, name: 'High'},
            {id: 2, name: 'Medium'},
            {id: 3, name: 'Low'}
        ]
    },
    mutations: {},
    actions: {},
    modules: {
        invoice,
        vendor,
        requisition,
        purchaseOrder,
        supplier,
        order,
        item,
        currency,
        warehouse,
        tax,
        payment,
        paymentMode,
        goodReceipt,
        creditNote,
        ledgerAccount,
        supplierGroup,
        supplierGroupList,
        supplierAccount,
        supplierContact,
        priority,
        debitNote,
        supplierAccountStatement,
        paymentAccount,
        account,
        generalReceipt,
        priceChecker
    }
}